export enum RouterTypes {
  HASH = 'hash',
  BROWSER = 'browser',
  MEMORY = 'memory',
  QUERY = 'query',
}

export interface RouterConfig {
  hashType?: 'slash' | 'noslash' | 'hashbang';
  basename?: string;
}
